module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('nav', [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'city',
        params: {
          city: 'bordeaux'
        }
      }
    }
  }, [_vm._v("Villes")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'city',
        params: {
          city: 'bordeaux'
        }
      }
    }
  }, [_vm._v("Recettes")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "id": "logo"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/logo.svg",
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("A propos")])], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "id": "menu-toggle"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.menuToggle($event)
      }
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "mailto:contact@tradfood.fr"
    }
  }, [_vm._v("Contact")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-672da84a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Header.vue
// module id = 68
// module chunks = 1